import { Typography } from "interfaces/typography";

export const NoDataState = ({ onRetry }: { onRetry: () => void }) => (
    <div className="w-full h-full flex flex-col items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6 max-w-lg text-center p-8">
        {/* No data icon */}
        <div className="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center">
          <svg 
            className="w-12 h-12 text-gray-400" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
            />
          </svg>
        </div>
        
        <div className="flex flex-col gap-3">
          <Typography variant="h2" color="gray">
            No Transcript Available
          </Typography>
          <Typography variant="mediumParagraph" color="gray">
            We couldn't find any call data. This might happen if there was an issue processing the transcript.
          </Typography>
        </div>
  
        <button 
          className="px-4 py-2 bg-indigo-700 text-white rounded-lg hover:bg-indigo-800 transition-colors"
          onClick={onRetry}
        >
          Retry
        </button>
      </div>
    </div>
  );
  